import { render, staticRenderFns } from "./KlientiStats.vue?vue&type=template&id=1094ef38&scoped=true&"
import script from "./KlientiStats.vue?vue&type=script&lang=js&"
export * from "./KlientiStats.vue?vue&type=script&lang=js&"
import style0 from "./KlientiStats.vue?vue&type=style&index=0&id=1094ef38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094ef38",
  null
  
)

export default component.exports